import { Link } from 'react-router-dom'
import { Seo } from '../components/seo/Seo'
import { BASE_PATH } from '../config/site'

export function NotFoundPage() {
  return (
    <section className="not-found shell shell--narrow">
      <Seo noIndex />
      <p className="not-found__code">404</p>
      <h1>This page wandered off.</h1>
      <p>The tool or page you were looking for doesn’t exist. Nothing was uploaded or changed.</p>
      <div className="home-hero__actions">
        <a className="button button--primary" href={BASE_PATH}>Back to home</a>
        <Link className="text-link" to="/images/">Browse image tools →</Link>
      </div>
    </section>
  )
}
